import NewCameraPositionDialog from "csi/threeD/cameraPositions3D/NewCameraPositionDialog";
import { routerStore } from "csi/state/rootStore";
import New from "csi/table/New";
import declare from "dojo/_base/declare";
import CameraPositionDialogStore from "csi/threeD/cameraPositions3D/CameraPositionStore";

const NewCameraPosition = declare(New, {
	/**
	 * @override
	 * Open React dialog
	 */
	preProcess: function (): void {
		const onSave = async (jsonResponse: Promise<void>): Promise<void> => {
			this.processReact(jsonResponse);
		};	

		const onCancel = (): void => {
			this.onCancelReactDialog();
		};

		const store = new CameraPositionDialogStore(onSave, onCancel, this.m_writer, this);
		this.useReactDialog(routerStore.openDialog(NewCameraPositionDialog, { store }));
	},
});

export = NewCameraPosition;